// ***********************************
// Profile.vue
// ***********************************
<template>
  <div id="app">
    <div class="container">
      <b-alert :show="showAlert" :variant="alertStyle">{{alertText}}</b-alert>
      <b-card v-if="!showAlert" header="User Profile: Database Metric Sharing"> 
        <b-list-group>
          <b-list-group-item>
            <div>
              <b>The following users are authorized to use DBCSI to work with your uploaded database(s) metrics.</b>
              <p/>
              
                          <!-- https://bootstrap-vue.js.org/docs/components/table/ -->

                          <b-table
                            responsive
                            hover
                            :items="allowed_list"
                            :fields="fields"
                          >
                                  <template v-slot:cell(actions)="row">
                                    <b-button size="sm" @click="deleteAuthorization(row.item, row.index, $event)" class="mr-1">
                                      Delete Authorization
                                    </b-button>
                                  </template>
                            <template v-slot:cell(show_details)="row">
                              <b-button
                                size="sm"
                                @click="row.toggleDetails"
                                class="mr-2"
                              >{{ row.detailsShowing ? 'Hide' : 'Show'}} Details</b-button>
                            </template>
                          </b-table>
              
<!--                <b-card
                  v-for="item in allowed_list"
                  :key="item.also_allowed_id"
                  :title="item.also_allowed_id"
                >
                                  <b-button
                  v-on:click="deleteAuthorization"
                  type="button"
                  v-b-tooltip.hover
                  title="Unauthorize this user"
                  block
                  variant="success"
                >Unauthorize this user</b-button>
                </b-card>
-->
             
            </div>
          </b-list-group-item>
          <b-list-group-item>
            <div>
              <b>To authorize another DBCSI user to be able to work with your uploaded database(s), enter their case-sensitive userID below.  Alternatively, you can provide their email address instead.</b>
              <b-card bg-variant="light" class="text-left" >
                <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                  <b-form-group
                    id="exampleInputGroup1"
                    label="Allowed userID:"
                    label-for="also_allowed_id"
                    description="UserID of another DBCSI user who you are authorizing to access your uploaded database(s) metrics."
                  >
                    <b-form-input
                      id="also_allowed_id"
                      type="text"
                      v-model="form.also_allowed_id"
                      :required="!form.also_allowed_email"
                      placeholder="Enter DBCSI userID"
                    ></b-form-input>
                  </b-form-group>
                  
                  <b-form-group
                    label="Or, email address:"
                    label-for="also_allowed_email"
                    description="If you don't know the userID, enter their email address and the system will look it up."
                  >
                    <b-form-input
                      id="also_allowed_email"
                      type="email"
                      v-model="form.also_allowed_email"
                      :required="!form.also_allowed_id"
                      :disabled="!!form.also_allowed_id"
                      placeholder="Enter email address (optional if userID is provided)"
                    ></b-form-input>
                  </b-form-group>
                  
                  <b-form-group
                    id="exampleInputGroup1"
                    label="Batch to share:"
                    label-for="form.batch_id"
                    description="The name of the specific batch you want to share, or select to share ALL your databases including databases you upload in the future."
                  >
                    <b-form-select v-model="form.batch_id" :options="batchChoices" >
                      <!--<template v-slot:first>-->
                      <!--  <b-form-select-option :value="null">Share ALL my databases</b-form-select-option>-->
                      <!--</template> -->
                    </b-form-select>
                  </b-form-group>
                  
                  <b-button type="submit" variant="primary">Submit</b-button>
                  <b-button type="reset" variant="danger">Reset</b-button>
                </b-form>
              </b-card>
            </div>
          </b-list-group-item>
        </b-list-group>
      </b-card>
      

    </div>
  </div>
</template>    


<script>
import { API, Storage } from "aws-amplify";
export default {
  name: "app",
  props: ["user"],
  data() {
    return {
      selected: null,
      output_file: null,
      form: {
        also_allowed_id: "",
        also_allowed_email: "",
        batch_id: "0"
      },
      show: true,
      showAlert: false,
      alertText: "",
      alertStyle: "default",
      allowed_list: [
          { also_allowed_id: 'loading authorized user list...' },
      ],
      fields: [
        { key: 'also_allowed_id', label: 'DBCSI UserID' },
        { key: 'batch_name', label: 'Batch' },
        { key: 'batch_customer', label: 'Customer' },
        { key: 'batch_id', label: 'BatchID' },
        { key: 'actions', label: 'Action' }
      ],
      batch_list: [
        {
          batch_id: "3",
          status: "please wait",
          statusLong: "please wait",
          descr: "",
          batch_date: "",
          customer: "Loading Data...",
          num_dbs: ""
        }
      ],
      batchChoices: [
          { value: '0', text: 'Share ALL my databases' },
          { value: 'd', text: 'Loading your list of batches...', disabled: true }
      ]


      
    };
  },
  async created() {
    // console.log("Profile: I am here1");
    var tries = 2;
    while (tries > 0) {
      await API.get("dbcsiAPI", `/dbcsi/person_share_list`)
        .then(response => {
          // console.log("Profile: I am here3");
          this.allowed_list = response.data;
          tries = 0;
          // console.log(this.genItems);
        })
        .catch(error => {
          console.log("Profile Error:", error);
          console.log("Will retry.  Attempts Left:", (tries-1));
        });
        
      await API.get("dbcsiAPI", `/dbcsi/batch`)
        .then(response => {
          // console.log("Profile: I am here3");
          this.batch_list = response.data;
          
          tries = 0;
          // console.log(this.genItems);
        })
        .catch(error => {
          console.log("Profile Error:", error);
          console.log("Will retry.  Attempts Left:", (tries-1));
        });

      this.batchChoices = [
          { value: '0', text: 'Share ALL my databases' },
          { value: '', text: '----------------------', disabled: true}
        ];
      for (var ii = 0; ii < this.batch_list.length; ii++) {
        // console.log('Main10')
        this.batchChoices.push({value: this.batch_list[ii].batch_id, text: this.batch_list[ii].batchname+' ('+this.batch_list[ii].customer+')' });
      }   
    
      tries -= 1;
    }


  },
  methods: {
    async onSubmit(evt) {
      evt.preventDefault();
      this.selected = null;
      this.alertStyle="primary";
      this.alertText = "Adding authorized user... Please wait...";
      this.showAlert = true;
      // console.log("Add: I am here1");
      var tries = 10;
      var success = false;
/*      while (tries > 0) {
        await API.get("dbcsiAPI", `/dbcsi/collections`)
          .then(response => {
            // console.log("Add: Aurora is ready");
            //   this.collection_list = response.data;
            tries = 0;
            success = true;
          })
          .catch(error => {
            console.log("Add.vue API Error (Aurura asleep? can retry):", error);
            console.log("Will retry.  Attempts Left:", (tries-1));
          });

        tries -= 1;
      } */
      
      success = true;
      if (success) {
        // console.log("Add: I am here4");
        //do a put to /person_share
        const putParams = {
          body: {
            also_allowed_id: this.form.also_allowed_id,
            also_allowed_email: this.form.also_allowed_email,
            batch_id: this.form.batch_id
          }
        };

        var new_id = null;
        var api_success = false;
        await API.put("dbcsiAPI", `/dbcsi/person_share`, putParams)
          .then(response => {
            // new_id = response.data.collection_id;
            api_success = true;
            // console.log("Profile API.put: new collection_id=", new_id);
          })
          .catch(error => {
            console.log("Profile API.put Error:", error);
            // alert("API.put error");
            if (error.response && error.response.data && error.response.data.error) {
              this.alertText = error.response.data.error;
            } else {
              this.alertText = "Database put error: " + error;
            }
            this.alertStyle="danger";
          });

        if (api_success) {
              this.alertText = "Userid authorized successfully.  You can refresh the page to continue.";
              this.alertStyle="success";
              
              this.form.also_allowed_id = "";
              this.form.also_allowed_email = "";
              /* Trick to reset/clear native browser form validation state */
              this.show = false;
              this.$nextTick(() => {
                this.show = true;
              });

        }
      }

      //   alert(JSON.stringify(this.form));
    },
    onReset(evt) {
      evt.preventDefault();
      /* Reset our form values */
      this.form.also_allowed_id = "";
      this.form.also_allowed_email = "";
      /* Trick to reset/clear native browser form validation state */
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },

    async deleteAuthorization(item, index, button) {
      /*           info(item, index, button) {
        this.infoModal.title = `Row index: ${index}`
        this.infoModal.content = JSON.stringify(item, null, 2)
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      */
      //evt.preventDefault();
      button.preventDefault();
      this.alertStyle="primary";
      this.alertText = "Deleting authorization for user... Please wait...";
      this.showAlert = true;

      //   console.log("putBatch: I am here1");
      var tries = 10;
      var success = true;

      if (success) {
        console.log("Profile-deleteAuth: Calling batch delete API");
        //do a del to /batch/:batch_id
        var batchParams = {
          body: {
            also_allowed_id: this.allowed_list[index].also_allowed_id,
            batch_id: this.allowed_list[index].batch_id
          }
        };
        await API.del(
          "dbcsiAPI",
          `/dbcsi/person_share`,
          batchParams
        )
          .then(response => {
            success = true;
            console.log("Profile-deleteAuth: delete success");
          })
          .catch(error => {
            console.log("Profile-deleteAuth: Error:", error);
              this.alertText = "Error while saving: "+error;
              this.alertStyle="danger";
              success=false;
          });

      }
      
              if (success) {
              this.alertText = "Userid authorization removed.  You can refresh the page to continue.";
              this.alertStyle="success";
              
              this.form.also_allowed_id = "";
              /* Trick to reset/clear native browser form validation state */
              this.show = false;
              this.$nextTick(() => {
                this.show = true;
              });

        }

    }
  }
  /* ,
  computed: {
    async allowed_list_filtered() {
    // console.log("Add: I am here1");
    var local_allowed_list=[];
    var tries = 10;
    while (tries > 0) {
      await API.get("dbcsiAPI", `/dbcsi/person_share_list`)
        .then(response => {
          // console.log("Add: I am here3");
          this.allowed_list = response.data;
          tries = 0;
          // console.log(this.genItems);
        })
        .catch(error => {
          console.log("Profile Error:", error);
          console.log("Will retry.  Attempts Left:", (tries-1));
        });

      tries -= 1;
    }
    return local_allowed_list;  
    }
  } */  
};
</script>

<style>
</style>
